import React from 'react';
import Layout from '../components/Layout/Layout';
import Seo from '../components/Seo/Seo';
import NewsComponent from '../components/News/News';
import Carousel from '../components/Carousel/Carousel';

const News = () => {
  return (
    <Layout>
      <Seo title="Apothéo - Nos News" description="Apothéo - Nos News" />
      {/* <Carousel /> */}
      <NewsComponent />
    </Layout>
  );
};

export default News;
